import 'vite/modulepreload-polyfill';
import './bootstrap.js';
import Pusher from 'pusher-js';
import Echo from "laravel-echo";
import createRealtime from './realtime.js';
window.Realtime = createRealtime(hostvars.realtime_enabled === true, () => {
    const endpoint = new URL(hostvars.realtime_url || window.location.origin);
    const options = {
        broadcaster: 'reverb',
        key: hostvars.realtime_key,
        wsHost: endpoint.hostname,
        wsPort: Number(endpoint.port || 80),
        wssPort: Number(endpoint.port || 443),
        forceTLS: endpoint.protocol === 'https:',
        enabledTransports: ['ws', 'wss'],
        disableStats: true,
        cluster: '',
    };
    return new Echo({ ...options, Pusher });
});

$(function () {
    Realtime.onStatus(status => {
        $('[data-realtime-status]').each(function () {
            $(this).text(hostvars.realtime_labels[status]);
            $(this).closest('[data-realtime-container]')
                .toggleClass('success', status === 'connected')
                .toggleClass('warning', status === 'disconnected');
        });
    });
});
